import CustomerBookings from './CustomerBookings';

export default CustomerBookings;
